<template>
  <div class="d-flex" style="gap: 8px;">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="white" depressed min-width="40" style="padding: 0 8px;">
          <v-icon color="primary" @click="decreaseFont">mdi-format-font-size-decrease</v-icon>
        </v-btn>
      </template>
      <span>Reduzir tamanho da fonte</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="white" depressed min-width="40" style="padding: 0 8px;">
          <v-icon color="primary" @click="resetFont">mdi-format-text-variant</v-icon>
        </v-btn>
      </template>
      <span>Resetar tamanho da fonte</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="white" depressed min-width="40" style="padding: 0 8px;">
          <v-icon color="primary" @click="increaseFont">mdi-format-font-size-increase</v-icon>
        </v-btn>
      </template>
      <span>Aumentar tamanho da fonte</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn @click="toggleDarkMode" v-on="on" color="white" depressed min-width="40" style="padding: 0 8px;">
          <v-icon color="primary">{{
            isDarkMode === "#fff"
              ? "mdi-white-balance-sunny"
              : "mdi-weather-night"
          }}</v-icon>
        </v-btn>
      </template>
      <span>Modo claro/escuro</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fontSize: 18, // Tamanho inicial da fonte
      maxFontSize: 22, // Limite máximo do tamanho da fonte
      minFontSize: 14, // Limite mínimo do tamanho da fonte
    };
  },

  computed: {
    isDarkMode() {
      return this.$vuetify.theme.dark ? "#000" : "#fff";
    },
  },

  methods: {
    decreaseFont() {
      this.fontSize = Math.max(this.fontSize - 2, this.minFontSize);
      this.updateFontSize();
    },
    resetFont() {
      this.fontSize = 18;
      this.updateFontSize();
    },
    increaseFont() {
      this.fontSize = Math.min(this.fontSize + 2, this.maxFontSize);
      this.updateFontSize();
    },
    updateFontSize() {
      document.documentElement.style.fontSize = this.fontSize + "px";
      this.$emit("font-size-changed", this.fontSize);
    },

    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem(
        "dark_theme",
        JSON.stringify(this.$vuetify.theme.dark)
      );
    },

    toggleMenu() {
      this.$store.commit("TOGGLE_SHOW_MENU_DRAWER");
    },
  },

  created() {
    const isDarkModeLocal = localStorage.getItem("dark_theme");
    if (isDarkModeLocal) {
      this.$vuetify.theme.dark = JSON.parse(isDarkModeLocal);
    }
  },
};
</script>

<style scoped>
.font-button {
}
</style>
